import React, {Component} from 'react';
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {Button as SementicBtn, Checkbox, Form, Input} from "semantic-ui-react";
import Update from "./Update";
import UpdateVIP from "./UpdateVIP";
import UpdatePublic from "./UpdatePublic";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import * as common from "../../../../const/Common/CommonFunc";
import {Icon, Spin} from "antd";
import apiConfig from "../../../../axios/axios_api_services";
import DrpDwn from "../../../../components/Dropdown/Dropdown/DrpDwn";
import * as DropDownConst from "../../../../store/Reducer/DropDownConst";
import TxtLbl from "../../../../components/Input/Input/TxtLbl";
import * as tableHeaders from "../../../../const/table/TableHeaders";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import QRCode from "qrcode";
import Delete from './Delete/Delete';
import axiosParkTags from "../../../../axios/axios_parktag";
import Pagination from "../../../../components/Pagination/Pagination";

class App extends Component {

  state = {
    isUpdate: false,
    corporate_data: null,
    isSpin: false,
    data: [],
    userType: 'PUBLIC',
    loading: false,
    qrImage:null,
    selectedName:'',
    deleteObj: null,
    size: 10,
    searchValue: '',
    page: 0,
    totalNoOfPages: 0,
    firstRow: 0,
    lastRow: 0,
    totalRows: 0
  };

  handleUpdate = () => {
    // this.getAllUsers();
    this.setState({
      isUpdate: !this.state.isUpdate
    })
  };

  updateCorporate = (obj) => {
    this.setState({
      corporate_data: obj,
      isUpdate: true
    });
  };

  changeSpinner = (condition) => {
    this.setState({
      isSpin: condition
    })
  };

  // getAllUsers = () => {
  //   const headers = {
  //     "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
  //   };
  //   this.changeSpinner(true);
  //   axiosTags.get(apiConfig.CORPORATE_SELECT_USER(this.props.usr_obj.corporateId), {headers: headers})
  //     .then(response => {
  //       if (response.data.success) {
  //
  //         this.setState({
  //           data: response.data.users
  //         })
  //
  //       } else {
  //         this.setState({
  //           data: []
  //         })
  //       }
  //     })
  //     .catch(async error => {
  //       let result = await common.checkErrorResponse(error);
  //       if (result === 1) {
  //       //  this.getAllUsers()
  //       }
  //     })
  //     .finally(fin => {
  //       this.changeSpinner(false);
  //     });
  // };

  componentDidMount() {
    this.setState({
      data: []
    });
    this.getAllUsers();
    // this.fetchData();
  }

  fetchData = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    this.setState({loading: true});
    axiosTags.get(apiConfig.SELECT_USER_TYPE(this.state.userType), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            data: response.data.body,
            loading: false
          })

        } else {
          this.setState({
            data: [],
            loading: false
          })
        }
        this.setState({
          loading: false
        })
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          //this.getAllUsers()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
        this.setState({
          loading: false
        })
      });
  };

  reloadTable = () => {
    // this.fetchData();
    this.getAllUsers();
  };

  selectUserType = () => async (event, {value}) => {
    /*this.setState({
      data: []
    });
    await this.setState({userType: value})
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    this.setState({loading: true})
    axiosTags.get(apiConfig.SELECT_USER_TYPE(this.state.userType), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            data: response.data.body,
            loading: false
          })

        } else {
          this.setState({
            data: [],
            loading: false
          })
        }
        this.setState({
          loading: false
        })
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          //  this.getAllUsers()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
      });*/
    await this.setState({userType: value,page: 0, searchValue: ''},()=>{
      this.getAllUsers();
    })
  };

  isVIPSelector = (obj, isVIP) => {
    if (!isVIP) {
      swal({
        text: 'Please add VIP points and click ok to update',
        icon: are_you_sure_icon,
        content: "input",
        type: 'number',
        button: {
          text: "Update!",
          closeModal: false,
        },
      })
        .then(points => {
          if (points !== null && /^[0-9.,]+$/.test(points)) {
            const headers = {
              "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
            };
            obj = {
              ...obj,
              points: points,
              vip: !obj.vip
            };

            this.props.spinnerHandler(true);
            axiosTags.patch(apiConfig.USER_VIP_STATE_UPDATE, obj, {headers: headers})
              .then(response => {
                if (response.data.success){
                  swal("Updated!", "User successfully updated!", "success");
                  this.getAllUsers();
                  // this.fetchData();
                }else{
                  swal("Sorry!", "Something went wrong!", "error");
                  // this.fetchData();
                  this.getAllUsers();
                }
              })
              .catch(async error => {
                swal("Sorry!", "Something went wrong!", "error");
                // this.fetchData();
                this.getAllUsers();
              })
              .finally(fin => {
                this.props.spinnerHandler(false);
              });
          } else {
            swal("Sorry!", "Input valid points", "error");
            // this.fetchData();
            this.getAllUsers();
          }
        })
    } else {
      swal({
        title: "Are you sure to remove VIP option from this user?",
        icon: are_you_sure_icon,
        buttons: true,
        dangerMode: true,
      })
        .then((willDelete) => {
          if (willDelete) {
            const headers = {
              "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
            };
            obj = {
              ...obj,
              vip: !obj.vip
            };
            this.props.spinnerHandler(true);
            axiosTags.patch(apiConfig.USER_VIP_STATE_UPDATE, obj, {headers: headers})
              .then(response => {
                if (response.data.success){
                  swal("Updated!", "User successfully updated!", "success");
                  // this.fetchData();
                  this.getAllUsers();
                }else{
                  swal("Sorry!", "Something went wrong!", "error");
                  // this.fetchData();
                  this.getAllUsers();
                }
              })
              .catch(async error => {
                swal("Sorry!", "Something went wrong!", "error");
                // this.fetchData();
                this.getAllUsers();
              })
              .finally(fin => {
                this.props.spinnerHandler(false);
              });
          } else {
            swal("VIP option did not changed!!");
            this.getAllUsers();
            // this.fetchData();
          }
        });
    }
    // .then(results => {
    //   return results.json();
    // })
    // .then(json => {
    //   const movie = json.results[0];
    //
    //   if (!movie) {
    //     return swal("No movie was found!");
    //   }
    //
    //   const name = movie.trackName;
    //   const imageURL = movie.artworkUrl100;
    //
    //   swal({
    //     title: "Top result:",
    //     text: name,
    //     icon: imageURL,
    //   });
    // })
    // .catch(err => {
    //   if (err) {
    //     swal("Oh noes!", "The AJAX request failed!", "error");
    //   } else {
    //     swal.stopLoading();
    //     swal.close();
    //   }
    // });

  };

  generateQR = (obj) => {

    this.props.spinnerHandler(true);

    QRCode.toDataURL(`${obj.mobile}`.toString(),{ scale: 10 })
      .then(url => {
        this.setState({qrImage: url,selectedName: `${obj.firstName !== null ? `${obj.firstName}` : ``} ${obj.lastName !== null ? `${obj.lastName}` : ``}`});
      })
      .catch(err => {
        console.error(err)
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };

  viewQRCode = (b64Code) => {
    let result = common.getB64ToBlob(b64Code);
    window.open(result, '_blank');
  };

  removeCorporateProfile = (obj) => {
    let delete_const = 'remove';
    swal({
      title: "Do you want to remove corporate profile? First please enter \"" + delete_const + "\"",
      icon: are_you_sure_icon, closeOnClickOutside: false, content: "input",
    })
      .then((value) => {
        if (value.trim() === delete_const) {
          this.deleteCorporateProfile(obj)
        } else {
          common.warningAlert("Can't remove account", 1)
        }
      });
  }

  deleteCorporateProfile = (obj) => {
    this.props.spinnerHandler(true);
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};

    axiosParkTags.delete(apiConfig.REMOVE_CORPORATE_PROFILE(obj.userId), {headers: headers})
      .then(response => {
        if (response.data.status === 200) {
          common.warningAlert(response.data.statusDesc, 0)
          // this.fetchData();
          this.getAllUsers();
        } else {
          common.warningAlert(response.data.statusDesc, 1)
        }
      })
      .catch(async error => {
        if(error && error.response && error.response.data) {
          common.warningAlert(error.response.data.statusDesc, 1)
        }else{
          let result = await common.checkErrorResponse(error);
          if (result === 1) this.deleteCorporateProfile(obj)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  onHandleChange = name => e => {
    let value = e.target.value;
    switch (name) {
      case "searchUser" :
        this.setState({searchValue : value});
        break;
      case "changeEntries" :
        this.setState({
          size : value,
          page : 0
        },() => {
          this.getAllUsers();
        });
        break;
      default:
        break;
    }
  }

  handlePagination = async (page) => {
    await this.setState({page: (page-1)})
    this.getAllUsers();
  }

  getAllUsers = () => {
    if(this.state.searchValue.trim() !== "") return this.searchAllUsersWithPagination(0);

    if (this.state.userType === 'PUBLIC') {
      this.getAllPublicUsersWithPagination();
    } else if (this.state.userType === 'CORPORATE') {
      this.getAllCorporateUsersWithPagination();
    } else if (this.state.userType === 'VIP') {
      this.getAllVIPUsersWithPagination();
    }
  }

  getAllPublicUsersWithPagination = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    this.setState({loading: true})
    axiosTags.get(apiConfig.SEARCH_PUBLIC_USERS_WITH_PAGINATION({index:this.state.page, size:this.state.size, searchValue:""}), {headers: headers})
      .then(response => {
        // console.log(response);
        if (response.data.success) {
          this.setState({
            data: response.data.body.content,
            page: response.data.body.number,
            totalNoOfPages: response.data.body.totalPages,
            firstRow: response.data.body.totalElements !== 0 ? response.data.body.pageable.offset + 1 : response.data.body.pageable.offset,
            lastRow: (response.data.body.pageable.offset + 1) + (response.data.body.numberOfElements - 1),
            totalRows: response.data.body.totalElements,
            loading: false
          })
        } else {
          this.setState({
            data: [],
            loading: false
          })
        }
        this.setState({
          loading: false
        })
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllUsers()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
        this.setState({
          loading: false
        })
      });
  }

  getAllCorporateUsersWithPagination = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    this.setState({loading: true})
    axiosTags.get(apiConfig.CORPORATE_SELECT_USER_WITH_PAGINATION({corporateId:this.props.usr_obj.corporateId,index:this.state.page,size:this.state.size,searchValue:""}), {headers: headers})
      .then(response => {
        // console.log(response);
        if (response.data.success) {
          this.setState({
            data: response.data.users.content,
            page: response.data.users.number,
            totalNoOfPages: response.data.users.totalPages,
            firstRow: response.data.users.totalElements !== 0 ? response.data.users.pageable.offset + 1 : response.data.users.pageable.offset,
            lastRow: (response.data.users.pageable.offset + 1) + (response.data.users.numberOfElements - 1),
            totalRows: response.data.users.totalElements,
            loading: false
          })
        } else {
          this.setState({
            data: [],
            loading: false
          })
        }
        this.setState({
          loading: false
        })
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllUsers()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
        this.setState({
          loading: false
        })
      });
  }

  getAllVIPUsersWithPagination = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    this.setState({loading: true})
    axiosTags.get(apiConfig.SEARCH_VIP_USERS_WITH_PAGINATION({index:this.state.page, size:this.state.size, searchValue:""}), {headers: headers})
      .then(response => {
        // console.log(response);
        if (response.data.success) {
          this.setState({
            data: response.data.body.content,
            page: response.data.body.number,
            totalNoOfPages: response.data.body.totalPages,
            firstRow: response.data.body.totalElements !== 0 ? response.data.body.pageable.offset + 1 : response.data.body.pageable.offset,
            lastRow: (response.data.body.pageable.offset + 1) + (response.data.body.numberOfElements - 1),
            totalRows: response.data.body.totalElements,
            loading: false
          })
        } else {
          this.setState({
            data: [],
            loading: false
          })
        }
        this.setState({
          loading: false
        })
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllUsers()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
        this.setState({
          loading: false
        })
      });
  }

  searchAllUsersWithPagination = (status) => {
    if (this.state.userType === 'PUBLIC') {
      this.searchPublicUsersWithPagination(status);
    } else if (this.state.userType === 'CORPORATE') {
      this.searchCorporateUsersWithPagination(status);
    } else if (this.state.userType === 'VIP') {
      this.searchVIPUsersWithPagination(status);
    }
  }

  searchPublicUsersWithPagination = (status) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    this.setState({loading: true});
    axiosTags.get(apiConfig.SEARCH_PUBLIC_USERS_WITH_PAGINATION({index:status === 1 ? 0 : this.state.page, size:this.state.size, searchValue:this.state.searchValue.trim()}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            data: response.data.body.content,
            page: response.data.body.number,
            totalNoOfPages: response.data.body.totalPages,
            firstRow: response.data.body.totalElements !== 0 ? response.data.body.pageable.offset + 1 : response.data.body.pageable.offset,
            lastRow: (response.data.body.pageable.offset + 1) + (response.data.body.numberOfElements - 1),
            totalRows: response.data.body.totalElements,
            loading: false
          })
        } else {
          this.setState({
            data: [],
            page: 0,
            totalNoOfPages: 0,
            firstRow: 0,
            lastRow: 0,
            totalRows: 0,
            loading: false
          })
        }
        this.setState({
          loading: false
        })
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllUsers()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
        this.setState({
          loading: false
        })
      });
  }

  searchCorporateUsersWithPagination = (status) => {
    // console.log(this.state.searchValue);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    this.setState({loading: true});
    axiosTags.get(apiConfig.CORPORATE_SELECT_USER_WITH_PAGINATION({corporateId:this.props.usr_obj.corporateId,index:status === 1 ? 0 : this.state.page,size:this.state.size,searchValue:this.state.searchValue.trim()}), {headers: headers})
      .then(response => {
        // console.log(response)
        if (response.data.success) {
          this.setState({
            data: response.data.users.content,
            page: response.data.users.number,
            totalNoOfPages: response.data.users.totalPages,
            firstRow: response.data.users.totalElements !== 0 ? response.data.users.pageable.offset + 1 : response.data.users.pageable.offset,
            lastRow: (response.data.users.pageable.offset + 1) + (response.data.users.numberOfElements - 1),
            totalRows: response.data.users.totalElements,
            loading: false
          })
        } else {
          this.setState({
            data: [],
            page: 0,
            totalNoOfPages: 0,
            firstRow: 0,
            lastRow: 0,
            totalRows: 0,
            loading: false
          })
        }
        this.setState({
          loading: false
        })
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllUsers()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
        this.setState({
          loading: false
        })
      });
  }

  searchVIPUsersWithPagination = (status) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    this.setState({loading: true});
    axiosTags.get(apiConfig.SEARCH_VIP_USERS_WITH_PAGINATION({index:status === 1 ? 0 : this.state.page, size:this.state.size, searchValue:this.state.searchValue.trim()}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            data: response.data.body.content,
            page: response.data.body.number,
            totalNoOfPages: response.data.body.totalPages,
            firstRow: response.data.body.totalElements !== 0 ? response.data.body.pageable.offset + 1 : response.data.body.pageable.offset,
            lastRow: (response.data.body.pageable.offset + 1) + (response.data.body.numberOfElements - 1),
            totalRows: response.data.body.totalElements,
            loading: false
          })
        } else {
          this.setState({
            data: [],
            page: 0,
            totalNoOfPages: 0,
            firstRow: 0,
            lastRow: 0,
            totalRows: 0,
            loading: false
          })
        }
        this.setState({
          loading: false
        })
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllUsers()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
        this.setState({
          loading: false
        })
      });
  }

  render() {
    let {deleteObj,size,firstRow,lastRow,page,totalRows,totalNoOfPages,userType} = this.state;
    let rows = [];
    let all_corporates = this.state.data;
    if (all_corporates.length !== 0) {
      all_corporates.map((cor, index) => {
        const obj = {
          index: index + 1,
          empID: cor.empId,
          fName: cor.firstName,
          lName: cor.lastName,
          mobile: cor.mobile,
          email: userType === "PUBLIC" ? cor.email : cor.corporateEntity === null ? cor.email : cor.corporateEmail,
          department: cor.department,
          idType: cor.identificationType,
          idValue: cor.identificationValue,
          gender: cor.gender,
          vip: cor.vip ? <label style={{
              paddingTop: '10px',
              paddingBottom: '10px',
              paddingLeft: '20px',
              paddingRight: '20px',
              color: 'white',
              backgroundColor: "green",
              borderRadius: '5px'
            }}>VIP</label> :
            <label
              style={{
                padding: '10px',
                color: 'white',
                backgroundColor: "red",
                borderRadius: '5px'
              }}> {this.state.userType === 'PUBLIC' ? 'Normal' : 'Staff'}  </label>,

          VIPType: cor.corporateEntity === null ? <label style={{
              paddingTop: '10px',
              paddingBottom: '10px',
              paddingLeft: '20px',
              paddingRight: '20px',
              color: 'black',
              backgroundColor: "#ffc107",
              borderRadius: '5px'
            }}>Public VIP</label> :
            <label style={{padding: '10px', color: 'black', backgroundColor: "#0d6efd", borderRadius: '5px'}}>Corporate
              VIP</label>,
          vipPoint: cor.points,
          activeVIP: <Checkbox toggle checked={cor.vip} onChange={() => this.isVIPSelector(cor, cor.vip)}/>,
          qr: cor.mobile !== null && <SementicBtn circular icon='qrcode' onClick={e => this.generateQR(cor)}/>,
          more:
            <>
             {/* <SementicBtn userType={this.state.userType} circular icon='edit' className={"more-update"}
                           onClick={() => this.updateCorporate(cor)}/>
              { cor.mobile !== null && this.state.userType === 'PUBLIC' && <SementicBtn circular icon='qrcode' onClick={e => this.generateQR(cor)}/> }*/}
              <button className={'cmn-edit-btn mr-1'} onClick={() => this.updateCorporate(cor)}>Edit</button>
              {this.state.userType === 'CORPORATE' && <button className={'cmn-delete-btn mr-1'} onClick={() => this.removeCorporateProfile(cor)}>Remove
                Corporate Profile</button>}
              <button className={'cmn-delete-btn'} onClick={() => this.setState({deleteObj: cor})}>Delete</button>
            </>
        };
        rows.push(obj)
      })
    }

    let columns = this.state.userType === 'CORPORATE' ? tableHeaders.ViewAllCorporateUser :
      this.state.userType === 'PUBLIC' ? tableHeaders.ViewAllPublicUser : tableHeaders.ViewAllVIPUser;
    let table_data = {columns, rows};

    return (
      <div>
        <Row>
          {
            this.state.isUpdate && this.state.userType === 'CORPORATE' ?
              <Update closeModal={this.handleUpdate} data={this.state.corporate_data} reloadTable={this.reloadTable}/>
              : this.state.isUpdate && this.state.userType === 'PUBLIC' ?
              <UpdatePublic closeModal={this.handleUpdate} data={this.state.corporate_data}
                            reloadTable={this.reloadTable}/> :
              this.state.isUpdate && this.state.userType === 'VIP' ?
                <UpdateVIP closeModal={this.handleUpdate} data={this.state.corporate_data}
                           reloadTable={this.reloadTable}/> : null
          }
          {deleteObj ? <Delete closeModalHandler={()=>this.setState({deleteObj:null})} data={deleteObj} refreshData={this.getAllUsers}/> : null}
          <Col lg="12">
            <Card>
              <CardHeader>
                All Users Details
              </CardHeader>
              <CardBody>
                <Row style={{marginBottom: '10px'}}>
                  <Col lg="5">
                    <Form.Group widths='equal'>
                      <DrpDwn
                        disabled={this.state.loading}
                        required
                        tagText={"Select User Type"}
                        placeholder={"User Type"}
                        value={this.state.userType}
                        options={DropDownConst.UserTypeDetails}
                        onChange={this.selectUserType('value')}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Spin spinning={this.state.isSpin} delay={10}
                      indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
                  <Row className={"align-items-center justify-content-between mb-2"}>
                    <Col lg={"2"} md={"3"} sm={"4"} xs={"4"}>
                      <Col className={"d-flex flex-column pl-0"}>
                        <label className={"font-smaller"}>Show entries</label>
                        <select style={{width: "50%"}} value={size} onChange={this.onHandleChange("changeEntries")}>
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                      </Col>
                    </Col>
                    <Col lg={"4"} md={"5"} sm={"7"} xs={"7"} className={"d-flex"}>
                      <Col className={"w-75"}>
                        <Input
                          className={"w-100"}
                          icon='search'
                          iconPosition='left'
                          placeholder='Search Here'
                          value={this.state.searchValue}
                          onChange={this.onHandleChange("searchUser")}
                        />
                      </Col>
                      <Col lg={"1.5"} md={"1.5"} sm={"1.5"} xs={"1.5"}>
                        <SementicBtn className="ui inverted primary button" onClick={()=>this.searchAllUsersWithPagination(1)}>Search</SementicBtn>
                      </Col>
                    </Col>
                  </Row>
                  <MDBDataTable
                    id={"all-corporate-table"}
                    searching={false}
                    searchLabel={"Search Corporate User"}
                    responsive
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    // striped={true}
                    paging={false}
                    bordered
                    hover
                    data={table_data}/>
                  <label className={"font-smaller mt-2"}>Showing {firstRow} to {lastRow} of {totalRows} entries</label>
                  <Row className={"align-items-center justify-content-center"}>
                    <Col lg={4} md={6} sm={12} xs={12}>
                      {/*<div className={"full-width align-center"}>*/}
                      { totalNoOfPages > 1 ? <Pagination activePage={(page + 1)} totalNoOfPages={totalNoOfPages}
                                                         handlePagination={this.handlePagination}/> : null}
                      {/*</div>*/}
                    </Col>
                  </Row>
                </Spin>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {
          this.state.qrImage ?
            <MDBModal isOpen={true} toggle={()=> {}} size="md" side position="top-right" className={"qr-code-branch"}>
              <MDBModalHeader className={"title-location"} toggle={()=>this.setState({qrImage: null})}>{this.state.selectedName}</MDBModalHeader>
              <MDBModalBody style={{padding:'0px'}}>
                <img src={this.state.qrImage} style={{border: "5px solid rgba(255, 0, 0, 0.5)"}}
                     className="image-qr-branch"/>

                <div className={"qr-btn-branch"}>
                  <a className={"view-qr-btn"} onClick={() => this.viewQRCode(this.state.qrImage)}>View QR
                    Code</a>
                  <a className={"view-qr-btn"} target={"_blank"} href={this.state.qrImage} download={"QR code_"+this.state.selectedName+".png"}>Download
                    QR Code</a>
                </div>
              </MDBModalBody>
            </MDBModal>:null
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  view_all_corporates: state.COPUserReducer.view_all_corporates_users, //not use
  corporate_headers: state.COPUserReducer.corporate_user_headers,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    getAllCorporateUsers: (data) => dispatch(actionCreator.getAllCorporateUsers(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
